import {
  IUomConversionAuditBulkUoms,
  IUomConversionAuditBulkUpdatePayload,
  IUomConversionAuditRow,
} from 'companySettings/types';

import { IBulkUpdateUomsForm } from './types';

/**
 * The report has one row per part + extracted UOM, so a part the import saw with
 * two units appears twice in a selection. Deduplicated here so the count the user
 * is told matches the parts actually written.
 */
export const getSelectedPartIds = (rows: IUomConversionAuditRow[]): number[] => [
  ...new Set(rows?.map((row) => row.partId) ?? []),
];

export const mapBulkUpdateUomsPayload = (
  data: IBulkUpdateUomsForm,
  rows: IUomConversionAuditRow[]
): IUomConversionAuditBulkUpdatePayload => {
  const uoms: IUomConversionAuditBulkUoms = {};

  // Only checked fields are sent: an absent key tells the server to leave that
  // column alone, while a present-but-empty one clears it.
  if (data.editUom) {
    uoms.uomId = data.uom?.id;
  }
  if (data.editSalesUom) {
    uoms.salesUom = data.salesUom ?? '';
  }
  if (data.editAlternateSalesUom) {
    uoms.alternateSalesUom = data.alternateSalesUom ?? '';
  }
  if (data.editPackageUom) {
    uoms.packageUom = data.packageUom ?? '';
  }
  if (data.editExternalUom) {
    uoms.externalUom = data.externalUom ?? '';
  }
  if (data.editAlternateUom) {
    uoms.alternateUom = data.alternateUom ?? '';
  }

  return { partIds: getSelectedPartIds(rows), uoms };
};
